module.exports = __webpack_public_path__ + "static/media/rawalpindi-dark.c558c4f2.svg";